import axiosConfig from './axiosConfig';

export const staffApi = {
  getStaff: () => axiosConfig.get('/staff'),
  addStaff: (staffData) => axiosConfig.post('/staff', staffData),
  updateStaff: (id, staffData) => axiosConfig.put(`/staff/${id}`, staffData),
  deleteStaff: (id) => axiosConfig.delete(`/staff/${id}`)
};
